/* ==========================================================================
   posthog-commerce.js :: theme-side commerce events (2026-08-22)

   Context: PostHog had ZERO commerce events. Verified 2026-08-22 by grepping
   the whole of ~/Ordin Studios, not just this theme:
     - snippets/ordin-attribution.liquid READS posthog ids and writes them to
       Shopify cart attributes. It contains no posthog.capture at all.
     - ordin-dashboard/api/*.js only READS PostHog (HogQL + insights) with a
       phx_ personal key. A personal key cannot ingest.
     - ordin-dashboard/ordin-tracking/shopify-posthog-events.js does fire
       add_to_cart_enriched / order_confirmed, but it is a paste-into-admin
       artifact from 2026-07-06 that was never installed (grep of every theme
       snapshot in out/ finds none of its event names).
     - There is no Web Pixel, no shopify.app.toml, no orders/* webhook.
   So the "attribution / ingestion engine DONE" line in CLAUDE.md is true for
   Shopify -> dashboard and false for anything -> PostHog.

   What this file adds:
     add_to_cart     every successful POST to /cart/add.js
     begin_checkout  every click that leaves for /checkout

   CONTRACT
   - No money arithmetic. Every price property is a Shopify-authored integer
     read straight off the /cart/add.js response (cents, as Shopify sends it)
     plus Shopify.currency.active. Nothing is summed, converted or formatted.
   - assets/cart.js is NOT touched. The bonus reconcile queue is untouched.
     This file observes fetch traffic and forwards it unmodified.
   - Fails soft everywhere: any throw inside the capture path is swallowed,
     and the original fetch promise is always what the caller receives.
   - The $0 auto-added bonus lines cannot show up here: reconcileBonuses uses
     /cart/update.js, not /cart/add.js. Zero-price lines are skipped anyway.

   NOT CAPTURABLE FROM A THEME: purchase / order completion. Shopify's
   checkout is off-domain, this SDK never runs there. See the changelog for
   the Web Pixel vs orders/paid webhook recommendation.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.fetch) return;

  function ph() {
    var p = window.posthog;
    return (p && typeof p.capture === 'function') ? p : null;
  }

  function currency() {
    try { return window.Shopify && window.Shopify.currency && window.Shopify.currency.active; }
    catch (e) { return undefined; }
  }

  function captureAdd(payload) {
    var p = ph();
    if (!p) return;
    var items = (payload && payload.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || !it.price) continue;   /* skip the $0 bonus lines */
      p.capture('add_to_cart', {
        product_handle: it.handle,
        product_id: it.product_id,
        product_title: it.product_title || it.title,
        variant_id: it.variant_id || it.id,
        variant_title: it.variant_title,
        quantity: it.quantity,
        /* Shopify's own integers, in cents. Not computed here. */
        price_cents: it.price,
        line_price_cents: it.final_line_price,
        currency: currency(),
        lines_in_request: items.length
      });
    }
  }

  /* ---- add_to_cart: observe, never alter, POSTs to /cart/add.js ---------
     A fetch wrapper is used rather than a form listener because every add
     path on this theme funnels through OrdinCart.add() in cart.js (the PDP
     form, the sticky ATC, the drawer upsell, the empty-state button), and
     hooking cart.js itself is out of bounds. */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var out = nativeFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && url.indexOf('/cart/add.js') !== -1) {
        out.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(captureAdd).catch(function () {});
        }).catch(function () {});
      }
    } catch (e) { /* observation must never break a cart request */ }
    return out;
  };

  /* ---- begin_checkout --------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var p = ph();
    if (!p) return;
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    var el = t.closest('.cart-drawer__cta, a[href^="/checkout"], a[href*="/checkouts/"], [name="checkout"]');
    if (!el) return;
    if (el.classList && el.classList.contains('cart-drawer__cta--disabled')) return;
    try {
      p.capture('begin_checkout', {
        source: el.classList && el.classList.contains('cart-drawer__cta') ? 'cart_drawer' : 'other',
        template: document.body.className,
        currency: currency()
      });
    } catch (err) { /* fail soft */ }
  }, true);
})();
